import { render, staticRenderFns } from "./BookmarkColumn.vue?vue&type=template&id=7720ed6e&scoped=true&"
import script from "./BookmarkColumn.vue?vue&type=script&lang=ts&"
export * from "./BookmarkColumn.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkColumn.vue?vue&type=style&index=0&id=7720ed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7720ed6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VList,VListItem,VListItemGroup})
